// extracted by mini-css-extract-plugin
export var cardBody = "b5_gL";
export var cardContent = "b5_gJ";
export var cardFooter = "b5_gK";
export var container = "b5_cn";
export var gridCardAParent = "b5_gM";
export var imageContainer = "b5_bT";